import { css } from "@emotion/core";
import { color } from "../../constants/commons";

export const bankAccountDetailsStyle = css`
  .internet-connectivity-block-info {
    background: ${color.white};
    border-radius: 0.25em;
    border: 1px solid ${color.gray};
    min-height: 4.25em;
    padding: 1em;
  }
  .display-content-style {
    color: ${color.lightishGray};
  }

  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .logo-responsive-styling {
      width: 20%;
    }
  }
  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .logo-responsive-styling {
      width: 8%;
    }
    .internet-connectivity-block-info-tabmonitor {
      background: ${color.white};
      border-radius: 0.25em;
      min-height: 4.8125em;
      padding: 1.25em;
    }
  }
  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .logo-responsive-styling {
      width: 8%;
    }
    .internet-connectivity-block-info-tabmonitor {
      background: ${color.white};
      border-radius: 0.25em;
      min-height: 4.8125em;
    }
  }
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .logo-responsive-styling {
      width: 4%;
    }
    .internet-connectivity-block-info-tabmonitor {
      background: ${color.whitishGray};
      border-radius: 0.25em;
      min-height: 4.8125em;
    }
  }
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .logo-responsive-styling {
      width: 4%;
    }
    .internet-connectivity-block-info-tabmonitor {
      background: ${color.whitishGray};
      border-radius: 0.25em;
      min-height: 4.8125em;
    }
  }
`;
